var _defs, _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCza(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-miterlimit:10;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0.9,
    y: 0.9,
    width: 18.2,
    height: 18.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.49,5.51a4.81,4.81,0,0,1,3.58-1.44A4.83,4.83,0,0,1,14.33,6a4.15,4.15,0,0,1,.79,2.17H12.69a3.22,3.22,0,0,0-.6-1.26,2.37,2.37,0,0,0-1.92-.76A2.38,2.38,0,0,0,8.12,7.22a5.22,5.22,0,0,0-.75,3,4.57,4.57,0,0,0,.79,2.93,2.49,2.49,0,0,0,2,1,2.28,2.28,0,0,0,1.91-.84,3.71,3.71,0,0,0,.6-1.35H15.1a5.26,5.26,0,0,1-1.6,3.1,4.67,4.67,0,0,1-3.29,1.19A5,5,0,0,1,6.3,14.65a6.49,6.49,0,0,1-1.42-4.44A6.47,6.47,0,0,1,6.49,5.51Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCza);
export default __webpack_public_path__ + "static/media/cza.8ba12d3bae76a8c8901d68c3a930d458.svg";
export { ForwardRef as ReactComponent };